import Axios, { AxiosResponse } from 'axios';
import ConfigurationService from './configuration-service';
var _token: string = '';

Axios.interceptors.response.use((response: AxiosResponse) => response, error => {
    let code = error && error.response && error.response.status ? error.response.status : 0;

    switch (code) {
        case 401:
            return Promise.resolve({
                data: {
                    success: false,
                    error: {
                        code: code,
                        message: "Usuário logado não possui permissão"
                    },
                    messages: [
                        {
                            index: 0,
                            message: "Usuário logado não possui permissão"
                        }
                    ]
                }
            });
        default:
            return Promise.reject(error);
    }
});


class BaseService {

    setToken = (token: string) =>{
        _token = token;
    }

    getToken = () =>{
        return _token;
    }

    get = async (endpoint: string, token: string) => {
        var config = {
            headers: { Authorization: `Bearer ${token}` }
        };
    
        return await Axios.get(endpoint, config);
    };

    getLogin = async (endpoint: string, token: string, username: string, password: string) => {
        var client_id = await ConfigurationService.getConfiguration('client_id');
        var config = {
            headers: { Authorization: `Bearer ${token}`,
                       username: username,
                       password: password,
                       client_id: client_id
         }
        };

        return await Axios.get(endpoint, config);
    };

    post = async (endpoint: string, token: string, data: any) => {
        var config = {
            headers: { Authorization: `Bearer ${token}` }
        };

        return await Axios.post(endpoint, data, config);
    };

    put = async (endpoint: string, data: any) => {
        return await Axios.put(endpoint, data);
    };

    delete = async (endpoint: string) => {
        return await Axios.delete(endpoint);
    };
}

export default BaseService;